/// <amd-module name="TFS/Admin/Views/AdminRoles/Components/AdminRoles" />
import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ConnectedAdminRolesInitializer } from "TFS/Admin/Views/AdminRoles/Components/AdminRolesInitializer";
import { getAdminRolesModule } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesModule";

export interface IAdminRolesProps {}

export class AdminRoles extends VssComponent<IAdminRolesProps> {
    private _context: IVssComponentContext;

    constructor(props: IAdminRolesProps, context: IVssComponentContext) {
        super(props, context);

        this._context = context;
    }

    public render(): JSX.Element {
        return (
            <DynamicModuleLoader modules={[getAdminRolesModule()]}>
                <ConnectedAdminRolesInitializer context={this._context} />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("adminRolesView", AdminRoles);
